import React, { useState } from 'react';

const defaultAuthData = {
  _id: null,
  roles: [],
  _type: null,
}
const AuthContext = React.createContext(defaultAuthData);

const AuthContextProvider = (props) => {
  const [authData, setAuthData] = useState({
    ...defaultAuthData,
  });
  const callback = () => {
    setAuthData({
      ...defaultAuthData,
    });
  }

  const setAuth = (data) => {
    setAuthData(data);
  }
  return (
    <AuthContext.Provider
      value={{
        setAuth,
        authData,
        callback,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

/*
 * We need this HOC for class components to pass data through props
 */
const withAuthContext = (Component) => (props) =>
  (
    <AuthContext.Consumer>
      {(authContextProps) => (
        <Component {...{ ...props, ...authContextProps }} />
      )}
    </AuthContext.Consumer>
  );

export { AuthContext, AuthContextProvider, withAuthContext };